import { useTrackingContext } from '../context/trackingContext';
import { useEffect, useState } from 'react';

export default function CookieBar(props) {
  const { trackClick, setTracking, declineCookie, trackReject, trackShowConsentModal } =
    useTrackingContext();
  const [cookieBar, setCookieBar] = useState(false);
  const { handleAccept, createTrackingUserId } = props;

  const acceptCookie = () => {
    localStorage.setItem('acceptCookie', '1');
    setCookieBar(false);
    setTracking(true);

    createTrackingUserId();
    trackClick({ btnName: 'Consent' });
  };

  const rejectCookie = () => {
    setCookieBar(false);
    trackReject();
    declineCookie();
  };

  useEffect(() => {
    const checkCookie = localStorage.getItem('acceptCookie');

    if (checkCookie === '0') {
      localStorage.removeItem('acceptCookie');
    }

    if (checkCookie) {
      handleAccept(checkCookie === '1');
      setCookieBar(false);
    } else {
      trackShowConsentModal();
      setCookieBar(true);
    }
  }, []);

  return cookieBar ? (
    <div className="fixed top-0 right-0 bottom-0 left-0 m-auto w-3/4 sm:w-1/2 md:w-1/3 h-96 z-10 ">
      <div className="items-center justify-around w-full bg-black p-4 pointer-events-auto mt-4 mx-auto mb-0 text-sm leading-none rounded-md">
        <div className="pb-4 text-white leading-5">
          We use functional and performance cookies to operate our website. With your consent, we
          would like to set analytical/targeting cookies to measure how you use this site and record
          statistical information. For more information, please read our{' '}
          <a
            className="underline"
            target="blank"
            href="https://www.buildarocketboy.com/privacy-notice">
            Privacy Notice
          </a>
          .
        </div>
        <div className="flex align-middle">
          <button
            className="m-auto px-4 py-2 transition flex flex-wrap items-center justify-center font-Korolev-Bold content-center select-none cursor-pointer uppercase bg-white text-black w-32 hover:text-white hover:bg-black border hover:border-white"
            onClick={acceptCookie}>
            I Consent
          </button>
          <button
            className="m-auto px-4 py-2 transition flex flex-wrap items-center justify-center font-Korolev-Bold content-center select-none cursor-pointer uppercase bg-white text-black w-32 hover:text-white hover:bg-black border hover:border-white "
            onClick={rejectCookie}>
            I Reject
          </button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
